import { IBooking, ISectionLayoutItem } from 'shared-types/index';

const NS = 'FunctionTrackerFilterService'; // jshint ignore:line

class FunctionTrackerFilterService {
  public filterBookings(ftBookings: IBooking[], sectionLayouts: ISectionLayoutItem[]): IBooking[] {
    if (!ftBookings) return [];

    // Find FT bookings matching the table Sections that are in Filter Selected Service SectionLayouts.
    const filteredBookings = ftBookings.filter((b) => {
      const tablesCount = b.tables.filter((t) => {
        if (!sectionLayouts) return false;
        const sectionsCount = sectionLayouts.filter((sl) => {
          // consider section only if its in used and open for the service.
          return (
            sl.sectionClosed === false && sl.sectionNotUsed == false && sl.sectionId === t.sectionId
          );
        }).length;
        return sectionsCount > 0;
      }).length;
      return tablesCount > 0;
    });

    return filteredBookings;
  }
}

const instance = new FunctionTrackerFilterService();
export default instance as FunctionTrackerFilterService;
